import React, { Component } from "react";
import { withStyles, InputLabel, FormControl, Input, FormHelperText, RadioGroup, Radio, FormControlLabel, Divider, DialogContent, InputAdornment, Button, IconButton, Icon, MenuItem, Card, TextField, Dialog, DialogActions, DialogTitle, Drawer, Avatar, Tooltip } from "@material-ui/core";
import { default as MaterialGrid } from '@material-ui/core/Grid';
import DropdownDefault from "../Layout/DropdownDefault";
import { Link } from "react-router-dom";
import CreateNewCompanyDialog from "./CreateNewCompanyDialog";
import CompanyProfileFrame from "./CompanyProfileFrame";
import moment from 'moment';//moment
import 'moment-timezone';//timezone
import HiddenColumns from "../Common/HiddenColumns";
import Server from "../../Common/Server"

import { FilterComponent } from './FilterComponent'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { ValidatorForm, TextValidator, SelectValidator } from "react-material-ui-form-validator";
import {
    Grid,
    DragDropProvider,
    Table,
    TableHeaderRow,
    Toolbar,
    ColumnChooser,
    VirtualTable,
    TableSelection,
    TableColumnVisibility,
    SearchPanel,
    TableFixedColumns,
    TableColumnReordering,
    PagingPanel,
    TableColumnResizing,
} from '@devexpress/dx-react-grid-material-ui';
import {
    SortingState,
    SearchState,
    IntegratedSorting,
    IntegratedFiltering,
    SelectionState,
    IntegratedSelection,
    PagingState,
    CustomPaging
} from '@devexpress/dx-react-grid';

import * as actions from '../../store/actions/index';
import { connect } from "react-redux";
import { compose } from 'redux';

import Snackbar from '@material-ui/core/Snackbar';
import Fade from '@material-ui/core/Fade';
import CircularProgress from '@material-ui/core/CircularProgress';
import LoadingState from "../Layout/LoadingState";
import InboxComposeMultipleDialog from "../CommonComposeMail/InboxComposeMultipleDialog";

let hiddneColumns = [];

const TooltipNew = withStyles((theme) => ({
    tooltip: {
        fontSize: 14,
    },
}))(Tooltip);

const DefaultSizeOFtext = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'inline-block',
    maxWidth: '42%',
    verticalAlign: 'middle',
    cursor: 'pointer'
}

class CompanyList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            deleteIds: [],
            currentPage: 0,
            pageSize: 10,
            column_name: "",
            sorttype: "",
            fieldId: 1,
            columns_array: [],
            isDeleteConfirmDialoOpen: false,
            defaultCurrentpage: 1,
            totalCount: 0,
            companyListData: [],
            updateColumnOrder: true,
            defaultColumnOrder: ['name'],
            column_ids: [],
            isOpenedCompanyList: true,
            isOpenedCustomFilters: false,
            isOpenedRange: false,
            shouldOpenCreateCompanyDialog: false,
            FullCreateCompanyDialog: false,
            minimizeCompanyDialog: false,
            defaulSortingData: [
                { columnName: 'name', direction: 'asc' },
                { columnName: "owner", direction: "desc" },
                { columnName: "phones", direction: "desc" },
                { columnName: "contacttype", direction: "desc" },
                { columnName: "visibility", direction: "desc" },
                { columnName: "emaildomain", direction: "desc" },
                { columnName: "lastcontacted", direction: "desc" },
                { columnName: "interactions", direction: "desc" },
                { columnName: "inactivedays", direction: "desc" },
            ],
            selection: [],
            companyLogs: [],
            filterObject: {},
            systemTagsList: [],
            systemCityListArray: [],
            systemStateListArray: [],
            systemZipcodeListArray: [],
            countryListArray: [],
            fieldDisplay: [],
            filterRangeArray: [],
            dropdownhide: [],
            filterSaveDialoge: false,
            fitertype: "1",
            filtername: "",
            recordtypeid: 3,
            filternameError: false,
            companyFilterListArray: [],
            displaySelectedFilterName: "All Companies",
            filterUpdateId: "",
            allowStateUpdateFilter: true,
            filterdata: [],
            activityquery: "any",
            tagsquery: "any",
            dateformat: 'MM/DD/YYYY',
            timeZone: 'America/New_York',
            usersListArray: [],
            AllCompanyFilterKey: "",
            columnWidths: [
                { columnName: "name", width: 250 },
                { columnName: "owner", width: 180 },
                { columnName: "phones", width: 180 },
                { columnName: "contacttype", width: 180 },
                { columnName: "visibility", width: 180 },
                { columnName: "emaildomain", width: 180 },
                { columnName: "lastcontacted", width: 180 },
                { columnName: "interactions", width: 180 },
                { columnName: "inactivedays", width: 180 },
            ],
            isDataLoading: true,
            newSavedFilterName: "",
            masterActivityTypesList: [],
            defaultHiddenColumnNames: [],
            hasRingCentralConnect: false,
            itegrationDetails: [],
            ringCentralData: [],
            sourceID: '',
            crudPermission: {
                iscreate: true,
                isdelete: true,
            },
            SelectedComapnyID: [],
            Companydata: [],
            relatedemails: [],
            userSelectedBlukEmail: [],
            isOpenedReplayBulkEmail: false,
            allSettings: "",
            IsSizeDefault: true,
        };
    }
    getUserPermission = () => {
        if (this.props.settingReducer.userPermissionDetails.data) {
            let udata = this.props.settingReducer.userPermissionDetails.data.data
            if (udata.teampermissionstatus === true &&
                udata.visibilityaccess.length > 0 &&
                this.props.authReducer.userRole.id === 3) {
                let leaddt = udata.visibilityaccess.find(function (element) { return element.sourcetype === 3; });
                this.setState({
                    crudPermission: {
                        iscreate: leaddt.iscreate,
                        isdelete: leaddt.isdelete,
                    }
                })
            }
        }
    }
    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }
    componentDidMount() {
        let userData = JSON.parse(localStorage.getItem('user_data_session'))
        let userprefparams = { userid: userData.id }
        this.props.getActivityTypes(this.props.apolloClient.client);
        this.props.getUserSetting(this.props.apolloClient.client, userprefparams);
        // this.props.getCityList(this.props.apolloClient.client);
        this.props.getFilterListCompany(this.props.apolloClient.client, 3);
        // this.props.getStateList(this.props.apolloClient.client);
        this.props.getZipcodeList(this.props.apolloClient.client);
        this.props.getUserList(this.props.apolloClient.client);
        this.props.getUserIntegration(this.props.apolloClient.client);
        this.props.generateMailBoxId(this.props.apolloClient.client);
        this.props.getEmailSetting(this.props.apolloClient.client);
        let val = {
            filterdata: this.state.filterdata,
            list: {
                limit: this.state.pageSize,
                pageno: 1,
                searchtext: this.state.searchText,
                sorttype: this.state.sorttype,
                type: "list",
                fieldId: this.state.fieldId,
                columnname: this.state.column_name
            },
            filterid: 1
        }
        this.getListing(val)
        // let params_customfield = { typeId:1 }
        // this.props.customFieldList(this.props.apolloClient.client, params_customfield);

    }
    getListing = (val) => {
        this.props.getCompanyRecFilterList(this.props.apolloClient.client, val);
        this.props.getCompanyRecListColumnOrder(this.props.apolloClient.client);
    }

    componentWillReceiveProps(props) {
        this.getUserPermission()

        if (props.settingReducer.generatedmailboxid.data) {
            let mailboxid = props.settingReducer.generatedmailboxid.data.mailboxid;
            this.setState({ mailboxid });
        }

        if (props.settingReducer.emailsettings.data) {
            const mian_data = props.settingReducer.emailsettings.data
            this.setState({
                allSettings: mian_data,
            })
        }

        if (props.settingReducer.masterActivityTypesList && props.settingReducer.masterActivityTypesList.is_loaded == true && props.settingReducer.masterActivityTypesList.data) {
            props.settingReducer.masterActivityTypesList.is_loaded = false
            var dataList = props.settingReducer.masterActivityTypesList.data;
            var count = dataList.filter(function (element) {
                if (element.is_disable == true) {
                    return element
                }
            });
            this.setState({
                masterActivityTypesList: dataList,
            });
        }
        if (props.settingReducer.userItegration.data && props.settingReducer.userItegration.data !== this.state.itegrationDetails) {
            let data = props.settingReducer.userItegration.data;
            let hasRingCentralConnect = false;
            data.map((item) => {
                if (item.status && item.integrationid == 10) {
                    hasRingCentralConnect = true;
                    console.log('Company List');
                    var rcs = document.createElement("script");
                    rcs.src = "https://ringcentral.github.io/ringcentral-embeddable/adapter.js?&disableGlip=true&disableConferenceCall=true&disableMessages=true&clientId=hPpoApgkSt2Hy1VZqUrrhQ";
                    var rcs0 = document.getElementsByTagName("script")[0];
                    rcs0.parentNode.insertBefore(rcs, rcs0);
                    if (window.RCAdapter) {
                        window.RCAdapter.setMinimized(false);
                        window.RCAdapter.setClosed(false);
                    }
                    window.addEventListener('message', (e) => {
                        const data = e.data;
                        if (data) {
                            switch (data.type) {
                                case 'rc-call-start-notify':
                                    console.log("web START calll", data.call);
                                    break;
                                case 'rc-call-end-notify':
                                    console.log("web END call", data.call);
                                    this.setState({ ringCentralData: data.call }, () => this.UpdateSettingRingCentral());
                                    break;
                                case 'rc-active-call-notify':
                                    console.log("web Active Call", data.call);
                                    break;
                                default:
                                    break;
                            }
                        }
                    });
                }
            });
            this.setState({
                itegrationDetails: data,
                hasRingCentralConnect: hasRingCentralConnect,
            });
        }

        if (props.settingReducer.getcontactRelatedData) {
            if (props.settingReducer.getcontactRelatedData.data && props.settingReducer.getcontactRelatedData.data.data) {
                let Companydata = props.settingReducer.getcontactRelatedData.data.data;
                let emails = [];
                if (Companydata && Companydata !== this.state.Companydata) {
                    Companydata.map((item) => {
                        if (item.__contactdetail__.length > 0) {
                            item.__contactdetail__.map((data) => {
                                if (data.__field__.id == "21" && data.values.length > 0) {//email
                                    emails.push(data.values[0].value);
                                    this.setState({ isDataLoading: false });
                                }
                            })
                        }
                    });
                    this.setState({
                        relatedemails: emails,
                        Companydata: Companydata,
                    });
                }
            }
        }

        if (props.settingReducer.usersListArray.data && this.state.usersListArray.length == 0) {
            const usersListArray = props.settingReducer.usersListArray.data;
            this.setState({ usersListArray: usersListArray })
        }
        if (props.settingReducer.userSettingArray && props.settingReducer.userSettingArray.data) {
            let usersetting = props.settingReducer.userSettingArray.data;

            let format = usersetting.dateformat;
            let timezone = usersetting.timezone;

            this.setState({ dateformat: format, timeZone: timezone })
        }

        if (props.companyReducer.companyFilterListArray.data && this.state.allowStateUpdateFilter || props.companyReducer.companyFilterListArray.is_loaded) {
            const companyFilterListArray = props.companyReducer.companyFilterListArray.data;
            props.companyReducer.companyFilterListArray.is_loaded = false
            this.setState({ companyFilterListArray: companyFilterListArray, allowStateUpdateFilter: false })

            var AllfilterIdKey = this.findWithAttr(companyFilterListArray, 'id', "7");
            if (AllfilterIdKey != -1) {
                this.setState({ AllCompanyFilterKey: AllfilterIdKey })
            }


            //Aplying default filter selected  STRAT

            let defaultFilter;
            //checkdefault filter  in localStorage
            var localStorageFilterId = localStorage.getItem('selected_company_filter_id');

            if (localStorageFilterId) {
                var localId = this.findWithAttr(companyFilterListArray, 'id', localStorageFilterId);
                defaultFilter = companyFilterListArray[localId];
            } else {
                var defaultKeyStatus = this.findWithAttr(companyFilterListArray, 'isdefault', true);
                defaultFilter = companyFilterListArray[defaultKeyStatus];
                localStorage.setItem('selected_company_filter_id', defaultFilter.id);
            }
            //updateFilter name to display and menudisplay array set
            this.setState({
                displaySelectedFilterName: this.state.newSavedFilterName ? this.state.newSavedFilterName : defaultFilter.filtername,
                fieldDisplay: [],
                dropdownhide: [],
            })

            //when Current Customers/Potential/following Customers filter select
            if (defaultFilter.id == "9") {
                defaultFilter.filteroption = [
                    {
                        fieldid: "33",
                        name: "contacttype",
                        type: "value",
                        value: ["Current Customer"],
                        checked: true,
                        text: "Current Customer"
                    }
                ]
            }
            if (defaultFilter.id == "10") {
                defaultFilter.filteroption = [
                    {
                        fieldid: "33",
                        name: "contacttype",
                        type: "value",
                        value: ["Potential Customer"],
                        checked: true,
                        text: "Potential Customer",
                    }
                ]
            }
            if (defaultFilter.id == "8") {
                defaultFilter.filteroption = [
                    {
                        fieldid: "0",
                        name: "followed",
                        type: "followed",
                        value: [true],
                        chktype: "follow",
                    }
                ]
            }

            if (defaultFilter.filteroption.length > 0) {
                let filterObject = this.state.filterObject;
                let filterRangeArray = this.state.filterRangeArray;
                let displayField = []
                let dropdownhideShow = []
                var promise = new Promise((resolve, reject) => {
                    defaultFilter.filteroption.map((val, k) => {
                        if (val.name == "activitytype") {
                            this.setState({ activityquery: val.query })
                            if (val.value.length > 0) {
                                var arr = []
                                val.value.map(v => {
                                    var k = this.findWithAttr(this.state.masterActivityTypesList, 'id', v)
                                    if (k != -1) {
                                        arr.push(this.state.masterActivityTypesList[k])
                                    }
                                })
                                val.value = arr;

                            }
                        }

                        filterObject = {
                            ...filterObject,
                            [val.name]: val
                        }

                        if (val.name == "tags") {
                            this.setState({ tagsquery: val.query })
                        }

                        if (val.type === "range") {
                            filterRangeArray[val.name] = ["", ""];
                            filterRangeArray[val.name][0] = val.value[0];
                            filterRangeArray[val.name][1] = val.value[1];
                            this.setState({ filterRangeArray })
                            displayField.push(val.name)
                        }
                        if (val.type === "date") {
                            filterRangeArray[val.name] = ["", ""];
                            filterRangeArray[val.name][0] = val.value[0] == "" ? null : val.value[0];
                            filterRangeArray[val.name][1] = val.value[1] == "" ? null : val.value[1];
                            this.setState({ filterRangeArray })
                            if (val.value[0] != "" && val.value[1] != "") {
                                displayField.push(val.name)
                            } else if (val.value[0] != "" || val.value[1] != "") {
                                displayField.push(val.name)
                            }
                        }
                        if (val.name == "zipcode" || val.name == "city" || val.name == "state" || val.name == "country") {//hideshow ENABLE state/city/country/state
                            dropdownhideShow.push(val.name)
                        } else {
                            dropdownhideShow.push(val.name)
                        }
                    })
                    this.setState({
                        filterObject,
                        fieldDisplay: displayField,
                        dropdownhide: dropdownhideShow,
                        newSavedFilterName: "",
                    }, () => this.forceUpdate())
                    resolve(true)
                });

                promise.then(result => {
                    this.handleFilterSubmit();
                });
            }
            //Aplying default filter selected  END
        }

        if (props.companyReducer.companyLogList.data && props.companyReducer.companyLogList.data && props.companyReducer.companyLogList.data.logdata) {
            this.setState({ companyLogs: props.companyReducer.companyLogList.data.logdata })
        }

        if (props.settingReducer.companyCustomFieldList.data) {
            const customFields = props.settingReducer.companyCustomFieldList.data;
            this.setState({ fieldsList: customFields })
        }

        if (props.settingReducer.systemCityListArray && props.settingReducer.systemCityListArray.data && this.state.systemCityListArray.length == 0) {
            this.setState({ systemCityListArray: props.settingReducer.systemCityListArray.data })
        }
        if (props.settingReducer.systemZipcodeListArray && props.settingReducer.systemZipcodeListArray.data && this.state.systemZipcodeListArray.length == 0) {
            this.setState({ systemZipcodeListArray: props.settingReducer.systemZipcodeListArray.data })
        }
        if (props.settingReducer.systemStateListArray && props.settingReducer.systemStateListArray.data && this.state.systemStateListArray.length == 0) {
            this.setState({ systemStateListArray: props.settingReducer.systemStateListArray.data })
        }
        if (props.settingReducer.countryListGql.data && this.state.countryListArray.length == 0) {
            const countryies = props.settingReducer.countryListGql.data;
            this.setState({ countryListArray: countryies })
        }

        if (props.settingReducer.systemTagsList.data && this.state.systemTagsList.length == 0) {
            const tagsData = props.settingReducer.systemTagsList.data;
            this.setState({ systemTagsList: tagsData })
        }

        if (props.companyReducer.companyFieldData.data && props.companyReducer.companyFieldData.is_loaded) {
            this.setState({
                isDataLoading: false,
            }, () => this.forceUpdate())
        }
        if (props.settingReducer.companyCustomFieldList.data) {
            let column_ids = this.state.column_ids;
            let columns_array = this.state.columns_array;
            let columnWidths = this.state.columnWidths;
            let defaultColumnOrder = this.state.defaultColumnOrder;
            let defaulSortingData = this.state.defaulSortingData;
            // const customFields = props.leadReducer.leadListOrder.data;

            // customFields.map((data) => {           
            //     if (data && (data.isactive || data.is_default) && data.field) {
            //         column_ids[data.field.fieldkey] = parseFloat(data.field.id);
            //         if (this.findWithAttr(columns_array, 'name', data.field.fieldkey) == -1) {
            //             // creating dynamic columns for table ------------------------
            //             columns_array.push({ name: data.field.fieldkey, title: data.field.fieldlabel });
            //             if (data.fieldkey != 'name')
            //                 defaultColumnOrder.push(data.field.fieldkey);
            //             if (data.fieldkey == 'name') {
            //                 console.log('DATA:', props.leadReducer.leadListOrder.data);
            //                 columnWidths.push(
            //                     { columnName: "name", width: 250 },
            //                 );
            //             } else {
            //                 columnWidths.push(
            //                     { columnName:data.field.fieldkey, width: 180 },
            //                 );
            //             }
            //         }
            //     }
            // });
            const customFields = props.settingReducer.companyCustomFieldList.data;

            customFields.map((field) => {
                if (field && (field.isdiactivated || field.is_default)) {
                    // if (field && field.id == '1') {
                    column_ids[field.fieldkey] = parseFloat(field.id);
                    if (this.findWithAttr(columns_array, 'name', field.fieldkey) == -1) {

                        // creating dynamic columns for table ------------------------
                        columns_array.push({ name: field.fieldkey, title: field.fieldlabel });
                        if (field.fieldkey != 'name')
                            defaultColumnOrder.push(field.fieldkey);

                        if (field.fieldkey == 'name') {
                            columnWidths.push(
                                { columnName: "name", width: 250 },
                            );
                        } else {
                            columnWidths.push(
                                { columnName: field.fieldkey, width: 180 },
                            );
                        }
                    }
                }
            });
            // if (this.findWithAttr(columns_array, 'name', 'statusupdatedate') == -1) {
            //     columns_array.push({ name: 'statusupdatedate', title: 'Status updatedate' });
            //     columnWidths.push({ columnName: 'statusupdatedate', width: 180 });
            //     defaultColumnOrder.push('statusupdatedate');
            // }
            // if (this.findWithAttr(columns_array, 'name', 'statusduration') == -1) {
            //     columns_array.push({ name: 'statusduration', title: 'Status Duration' })
            //     columnWidths.push({ columnName: 'statusduration', width: 180 });
            //     defaultColumnOrder.push('statusduration');
            // }
            if (this.findWithAttr(columns_array, 'name', 'lastcontacted') == -1) {
                columns_array.push({ name: 'lastcontacted', title: 'Last Contacted' })
                columnWidths.push({ columnName: 'lastcontacted', width: 180 });
                defaultColumnOrder.push('lastcontacted');
            }
            if (this.findWithAttr(columns_array, 'name', 'interactions') == -1) {
                columns_array.push({ name: 'interactions', title: 'Interactions' })
                columnWidths.push({ columnName: 'interactions', width: 180 });
                defaultColumnOrder.push('interactions');
            }
            if (this.findWithAttr(columns_array, 'name', 'inactivedays') == -1) {
                columns_array.push({ name: 'inactivedays', title: 'Inactive Days' })
                columnWidths.push({ columnName: 'inactivedays', width: 180 });
                defaultColumnOrder.push('inactivedays');
            }
            this.setState({ column_ids: column_ids, columnWidths: columnWidths, columns_array: columns_array, defaultColumnOrder: defaultColumnOrder, }, () => this.forceUpdate());
            if (this.state.drawerflag) {
                setTimeout(() => {
                    this.setState({ drawerOpen: true, drawerflag: false }, () => this.forceUpdate())
                }, 500);
            }
            if (props.companyReducer.companyListOrder && props.companyReducer.companyListOrder.data && props.companyReducer.companyListOrder.data.length > 0) {
                let ordernoList = [];
                let list = [];
                let newcolumn_arr = [];
                let hidddenCol = ['lastname'];

                props.companyReducer.companyListOrder.data.map((listOrder) => {
                    if (listOrder.field) {
                        if (listOrder.field.fieldkey != "name") {
                            if (listOrder.isactive == false)
                                hidddenCol.push(listOrder.field.fieldkey);

                            ordernoList.push(listOrder.field.fieldkey);
                        }
                        if (this.state.columns_array) {
                            let key_col = this.findWithAttr(this.state.columns_array, 'name', listOrder.field.fieldkey);
                            newcolumn_arr.push(this.state.columns_array[key_col]);
                        }
                    } else {
                        let temp_order = props.companyReducer.company_column_order_extra[0];
                        let companycol = Object.keys(temp_order).find(key => temp_order[key] == listOrder.columnid);

                        if (listOrder.isactive == false)
                            hidddenCol.push(companycol);

                        ordernoList.push(companycol)
                        if (this.state.columns_array) {
                            let key_col = this.findWithAttr(this.state.columns_array, 'name', companycol);
                            newcolumn_arr.push(this.state.columns_array[key_col]);
                        }
                    }
                });

                this.setState({ columns_array: newcolumn_arr });

                if (this.state.updateColumnOrder)
                    this.setState({ defaultColumnOrder: ordernoList, defaultHiddenColumnNames: hidddenCol }, () => this.forceUpdate());
            }
        }
        if (props.companyReducer.companyList.data && props.companyReducer.companyList.data.data) {
            let totalRecord = props.companyReducer.companyList.data.totalrecord;
            this.setState({ totalCount: totalRecord });
            let listrows = [];
            let columns_array = this.state.columns_array;
            // // for displaying table rows dynamically-------------------
            props.companyReducer.companyList.data.data.map((companydata, companyindex) => {

                let row_str = [];
                let thisVar = this;
                let company_name = '';

                Object.keys(companydata).forEach(function (key) {
                    columns_array.map((colm) => {

                        if (!row_str[colm.name]) {
                            if (colm.name == "name") {//name field
                                let star_icon = companydata['isfavourite'] ? "star" : "star_border";
                                let color_class = (companydata[colm.name] && companydata[colm.name].length > 0) ? companydata[colm.name].charAt(0).toLowerCase() : "";
                                let data = '-';
                                company_name = companydata[colm.name];
                                data = (
                                    <div className="white_space_nowrap">
                                        {!companydata['image'] && <Avatar className={"avatar_circle color_" + color_class}>{color_class.toUpperCase()}</Avatar>}
                                        {companydata['image'] && <Avatar className="avatar_circle color_a" alt="Company image" src={companydata['image']} />}

                                        <span className="font-weight-500 hover_name" style={DefaultSizeOFtext}>
                                            <Link to={"/company/company/" + companydata['company_id']}>{companydata[colm.name]}</Link>
                                        </span>
                                        <IconButton className={'text-secondary ml-4' + ' ' + (star_icon == 'star' ? 'visibleStarIcon' : '')} onClick={(company, status) => thisVar.handleFavorite(companydata['company_id'], companydata['isfavourite'])} size="small">
                                            <Icon>{star_icon}</Icon>
                                        </IconButton>
                                        <IconButton size="small" className="user_info ml-4" color="primary" onClick={(e) => thisVar.handleDrawerRight(companydata['company_id'])}>
                                            <Icon>remove_red_eye</Icon>
                                        </IconButton>
                                    </div>);

                                if (!row_str[colm.name])
                                    row_str[colm.name] = data;
                            }

                            else if (colm.name == "value") {//Value fiels
                                let value = '-';
                                if (companydata[colm.name]) {
                                    companydata[colm.name].map((statusdata) => (
                                        value = (statusdata.srno == 1) ? statusdata.value : null
                                    ))
                                }
                                if (!row_str[colm.name])
                                    row_str[colm.name] = value;
                            }
                            else if (colm.name == "websites" || colm.name == "social" || colm.name == "phones" || colm.name == "email" || colm.name == "status" || colm.name == "source" || colm.name == "visibility" || colm.name == "contacttype" || colm.name == "tags") {
                                let data = '-';
                                let hasRingCentralConnect = thisVar.state.hasRingCentralConnect;
                                if (companydata[colm.name]) {
                                    if (colm.name == "email") {
                                        companydata[colm.name].map((statusdata) => (
                                            data = (statusdata.srno == 1) ? <a href={"mailto:" + statusdata.value} className="text_link">{statusdata.value}</a> : null
                                        ))
                                    }
                                    if (colm.name == "phones") {
                                        companydata[colm.name].map((statusdata) => {
                                            if (parseInt(statusdata.srno) == 1) {
                                                data = hasRingCentralConnect === true ?
                                                    <a href={"tel:" + statusdata.value} onClick={() => thisVar.handleSetId(companydata['company_id'], company_name)} className="text_link">{statusdata.value}</a> : statusdata.value;
                                            }
                                        })
                                    }
                                    if (colm.name == "websites") {
                                        companydata[colm.name].map((statusdata) => (
                                            data = (statusdata.srno == 1) ? <a href={statusdata.value} className="text_link">{statusdata.value}</a> : null
                                        ))
                                    }
                                    if (colm.name == "social" || colm.name == "status" || colm.name == "source" || colm.name == "visibility" || colm.name == "contacttype") {
                                        companydata[colm.name].map((statusdata) => {
                                            if (statusdata.srno == 1) {
                                                data = statusdata.value;
                                            }
                                        })
                                    }
                                    if (colm.name == "tags") {
                                        let tag = [];
                                        companydata[colm.name].map((statusdata) => {
                                            statusdata.value && tag.push(statusdata.value)
                                        })

                                        data = (tag.toString()) ? tag.toString() : null
                                    }
                                }


                                if (!row_str[colm.name])
                                    row_str[colm.name] = data;
                            }
                            else if (colm.name == "owner") {
                                let data = '-';
                                if (companydata[colm.name]) {
                                    if (typeof (companydata[colm.name]) == "string") {
                                        data = companydata[colm.name];
                                    }
                                    else {
                                        companydata[colm.name].map((statusdata) => (
                                            data = (statusdata.srno == 1) ? statusdata.name : null
                                        ))
                                    }
                                }

                                if (!row_str[colm.name])
                                    row_str[colm.name] = data;
                            }
                            // { statusupdatedate: 1001, statusduration: 1002, lastcontacted: 1003, interactions: 1004, inactivedays: 1005 }
                            else if (colm.name == "statusupdatedate" || colm.name == "lastcontacted") {
                                let data = '-';
                                data = companydata[colm.name] ?
                                    moment.unix(companydata[colm.name]).tz(thisVar.state.timeZone).format(thisVar.state.dateformat)
                                    : '-';

                                if (!row_str[colm.name])
                                    row_str[colm.name] = data;
                            }
                            else if (colm.name == "statusduration" || colm.name == "interactions" || colm.name == "inactivedays") {
                                let data = '-';
                                data = companydata[colm.name] ? companydata[colm.name] : '-';

                                if (!row_str[colm.name])
                                    row_str[colm.name] = data;
                            }

                            else {
                                let data = '-'
                                if (thisVar.state.fieldsList) {
                                    if (companydata[colm.name]) {
                                        var key = thisVar.findWithAttr(thisVar.state.fieldsList, 'fieldkey', colm.name);
                                        if (key != -1) {
                                            if (thisVar.state.fieldsList[key].is_default == false && (thisVar.state.fieldsList[key].fieldtype.id == "4")) {
                                                companydata[colm.name].map((statusdata) => (
                                                    data = (statusdata.srno == 1) ? statusdata.value : null
                                                ))
                                            }
                                            if (thisVar.state.fieldsList[key].fieldtype.id == "5") {
                                                console.log("data in checkbox ", companydata[colm.name])
                                                let maindata = [];
                                                companydata[colm.name].map((statusdata) => {
                                                    statusdata.value && maindata.push(statusdata.value)
                                                })
                                                data = (maindata.toString()) ? maindata.toString() : null
                                            }
                                            if (thisVar.state.fieldsList[key].fieldtype.id == "1" || thisVar.state.fieldsList[key].fieldtype.id == "2") {

                                                data = companydata[colm.name] ? companydata[colm.name] : null
                                            }
                                            if (thisVar.state.fieldsList[key].fieldtype.id == "6") {//
                                                data = companydata[colm.name]
                                            }
                                            if (thisVar.state.fieldsList[key].fieldtype.id == "7") {//date field
                                                data = companydata[colm.name] + "%"
                                            }
                                            // //validating date fields
                                            if (thisVar.state.fieldsList[key].fieldtype.id == "8") {//date field
                                                //data = moment.unix(companydata[colm.name]).tz(thisVar.state.timeZone).format(thisVar.state.dateformat)
                                                data = moment(companydata[colm.name]).format(thisVar.state.dateformat)
                                            }
                                            if (thisVar.state.fieldsList[key].fieldtype.id == "9") {
                                                data = companydata[colm.name] ?
                                                    <a href={companydata[colm.name]} className="text_link">{companydata[colm.name]}</a>
                                                    : null
                                            }
                                            if (thisVar.state.fieldsList[key].fieldtype.id == "10") {
                                                data = companydata[colm.name]
                                            }
                                            if (!row_str[colm.name])
                                                row_str[colm.name] = data;
                                        }
                                    }
                                }
                            }
                        }
                    });
                });
                let row_str_data = Object.assign({}, row_str);
                listrows.push(row_str_data)
                row_str = [];
            });

            this.setState({
                isDataLoading: false,
            }, () => this.forceUpdate())
            this.setState({ companyListData: listrows }, () => this.forceUpdate());
        }
        else {
            let listrows = [];
            this.setState({
                companyListData: listrows,
            }, () => {
                this.forceUpdate()

                setTimeout(() => {
                    this.setState({
                        isDataLoading: false,
                    })
                }, 3000);
            })
        }


    }

    UpdateSettingRingCentral = () => {
        let data = [];
        if (this.state.ringCentralData.direction === "Outbound") {
            data['data'] = {
                direction: this.state.ringCentralData.direction,
                telephonyStatus: this.state.ringCentralData.callStatus,
                fromphoneNumber: this.state.ringCentralData.fromNumber,
                fromName: this.state.company_name,
                phoneNumber: this.state.ringCentralData.to,
                startTime: this.state.ringCentralData.startTime
            };
            console.log(data['data'], "jhsbdjbcjs");
            let req = {
                text: JSON.stringify(data['data']),
                sourcetype: 3,
                sourceid: parseInt(this.state.sourceID),
            }
            console.log(req, 'UpdateSettingRingCentral');
            this.props.saveRingCentralData(this.props.apolloClient.client, req);
        }

    }

    handleSetId = (id, name) => {
        this.setState({ sourceID: id, company_name: name });
    }

    onColumnWidthsChange = (widths) => {
        let IsSizeDefault;
        widths.map((NameSize) => { 
            if(NameSize.columnName === 'name' && NameSize.width !== 250 ){
                IsSizeDefault = false;
            }
         });
        this.setState({ IsSizeDefault : IsSizeDefault });
    }
    handleChangeColumnOrder = (val) => {

        let arr_ids = [];
        let arr_orders = [];
        let arr_status = [];
        let columns = [];
        let hiddens = this.state.defaultHiddenColumnNames;

        val.map((col, key) => {

            if (col == 'interactions' || col == 'inactivedays' || col == 'lastcontacted') {
                if (this.props.companyReducer.company_column_order_extra[0][col] != null) {
                    arr_ids.push(this.props.companyReducer.company_column_order_extra[0][col])
                    arr_orders.push(key + 1);
                    columns.push(col);

                    if (hiddens.indexOf(col) == -1)
                        arr_status.push(true)
                    else
                        arr_status.push(false)
                }
            }
            else {
                if (this.state.column_ids[col] != null) {
                    arr_ids.push(this.state.column_ids[col]);
                    arr_orders.push(key + 1);
                    columns.push(col);

                    if (hiddens.indexOf(col) == -1)
                        arr_status.push(true)
                    else
                        arr_status.push(false)
                }
            }
        });

        this.setState({ updateColumnOrder: false, defaultColumnOrder: columns });
        let changeColumnOrderparams = {
            fieldid: arr_ids,
            columnstatus: arr_status,
            orderno: arr_orders
        };
        this.props.updateCompanyRecListColumnOrder(this.props.apolloClient.client, changeColumnOrderparams);

    }
    // handleChangeColumnHidden = (val) => {
    //     let arr_ids = [];
    //     let arr_orders = [];
    //     let arr_status = [];
    //     let columns = [];
    //     const colsOrder = this.state.defaultColumnOrder;

    //     colsOrder.map((col, key) => {
    //         if (col == 'interactions' || col == 'inactivedays' || col == 'lastcontacted') {
    //             if (this.props.companyReducer.company_column_order_extra[0][col] != null) {
    //                 arr_ids.push(this.props.companyReducer.company_column_order_extra[0][col])
    //                 arr_orders.push(key + 1);
    //                 columns.push(col);

    //                 if (val.indexOf(col) == -1)
    //                     arr_status.push(true)
    //                 else
    //                     arr_status.push(false)
    //             }
    //         }
    //         else {
    //             if (this.state.column_ids[col] != null) {
    //                 arr_ids.push(this.state.column_ids[col]);
    //                 arr_orders.push(key + 1);
    //                 columns.push(col);

    //                 if (val.indexOf(col) == -1)
    //                     arr_status.push(true)
    //                 else
    //                     arr_status.push(false)
    //             }
    //         }
    //     });


    //     let changeColumnOrderparams = {
    //         fieldid: arr_ids,
    //         columnstatus: arr_status,
    //         orderno: arr_orders
    //     };

    //     this.setState({ updateColumnOrder: false, defaultHiddenColumnNames: val });
    //     this.props.updateCompanyRecListColumnOrder(this.props.apolloClient.client, changeColumnOrderparams);
    // }
    handleChangeColumnHidden = (val) => {
        hiddneColumns = val;
        this.setState({ defaultHiddenColumnNames: hiddneColumns });
    }
    handleHiddensMain = (hiddens) => {
        console.log(hiddens, 'hiddens');

        let arr_ids = [];
        let arr_orders = [];
        let arr_status = [];
        let columns = [];
        hiddneColumns = hiddens;
        let colsOrder = this.state.defaultColumnOrder;

        colsOrder.map((col, key) => {

            if (col == 'statusupdatedate' || col == 'statusduration' || col == 'interactions' || col == 'inactivedays' || col == 'lastcontacted') {
                if (this.props.companyReducer.company_column_order_extra[0][col] != null) {
                    arr_ids.push(this.props.companyReducer.company_column_order_extra[0][col])
                    arr_orders.push(key + 1);
                    columns.push(col);

                    if (hiddens.indexOf(col) == -1)
                        arr_status.push(true)
                    else
                        arr_status.push(false)
                }
            }
            else {
                if (this.state.column_ids[col] != null) {
                    arr_ids.push(this.state.column_ids[col]);
                    arr_orders.push(key + 1);
                    columns.push(col);

                    if (hiddens.indexOf(col) == -1)
                        arr_status.push(true)
                    else
                        arr_status.push(false)
                }
            }
        });

        let changeColumnOrderparams = {
            fieldid: arr_ids,
            columnstatus: arr_status,
            orderno: arr_orders
        };

        this.setState({ updateColumnOrder: false, defaultHiddenColumnNames: hiddneColumns });
        this.props.updateCompanyRecListColumnOrder(this.props.apolloClient.client, changeColumnOrderparams);
    }

    handleFavorite = (company, status) => {
        let setFavoriteParams = [];
        setFavoriteParams['favorite'] = { status: !status, companyid: company };
        setFavoriteParams['listval'] = {
            filterdata: this.state.filterdata,
            list: {
                limit: this.state.pageSize,
                pageno: this.state.currentPage + 1,
                searchtext: this.state.searchText,
                sorttype: this.state.sorttype,
                type: "list",
                fieldId: this.state.fieldId,
                columnname: this.state.column_name
            },
            filterid: 1
        };


        this.props.addFavouriteCompanyRec(this.props.apolloClient.client, setFavoriteParams);
    }

    handleCurrentPage = (page) => {
        this.setState({
            currentPage: page,
            selection: [],
        })

        let params_for_pagechange = {
            filterdata: this.state.filterdata,
            list: {
                limit: this.state.pageSize,
                pageno: page + 1,
                searchtext: this.state.searchText,
                sorttype: this.state.sorttype,
                type: "list",
                fieldId: this.state.fieldId,
                columnname: this.state.column_name
            },
            filterid: 1
        }
        this.getListing(params_for_pagechange);
    }
    handlePageSize = (size) => {

        this.setState({
            pageSize: size,
            currentPage: 0,
            selection: [],
        })

        let params_for_pagesize = {
            filterdata: this.state.filterdata,
            list: {
                limit: size,
                pageno: 1,
                searchtext: this.state.searchText,
                sorttype: this.state.sorttype,
                type: "list",
                fieldId: this.state.fieldId,
                columnname: this.state.column_name
            },
            filterid: 1
        }
        this.getListing(params_for_pagesize);
    }

    toggleCompanyList = () => {
        this.setState(oldStateCompanyList => ({ isOpenedCompanyList: !oldStateCompanyList.isOpenedCompanyList }));
    }
    toggleCustomFilters = () => {
        this.setState(oldStateCustomFilters => ({ isOpenedCustomFilters: !oldStateCustomFilters.isOpenedCustomFilters }));
    }
    toggleRange = (e) => {
        e.preventDefault();
        this.setState(oldStateRange => ({ isOpenedRange: !oldStateRange.isOpenedRange }));
    }
    changeDefaultSorting = (val) => {
        let column = val[0].columnName;
        let direction = val[0].direction;

        let data = this.state.defaulSortingData;
        data = data.filter(sort => sort.columnName !== val[0].columnName).map(sort => {
            sort.direction = "desc"
            return sort;
        })
        data.push(val[0]);
        this.setState({
            defaulSortingData: data,
            sorttype: direction
        }, () => this.forceUpdate)

        if (column == 'statusupdatedate' || column == 'statusduration' || column == 'interactions' || column == 'inactivedays' || column == 'lastcontacted') {
            let params_for_sort = {
                filterdata: this.state.filterdata,
                list: {
                    limit: this.state.pageSize,
                    pageno: this.state.currentPage + 1,
                    searchtext: this.state.searchText,
                    sorttype: direction,
                    type: "sort",
                    fieldId: 0,
                    columnname: column
                },
                filterid: 1
            }
            this.getListing(params_for_sort);
            this.setState({ fieldId: 0, column_name: column });
        } else if (this.state.column_ids[column]) {
            let params_for_sort = {
                filterdata: this.state.filterdata,
                list: {
                    limit: this.state.pageSize,
                    pageno: this.state.currentPage + 1,
                    searchtext: this.state.searchText,
                    sorttype: direction,
                    type: "sort",
                    fieldId: this.state.column_ids[column],
                    columnname: column
                },
                filterid: 1
            }
            this.getListing(params_for_sort);
            this.setState({ fieldId: this.state.column_ids[column], column_name: column });
        }

        let columnWidths = this.state.columnWidths;
        let IsSizeDefault;
        columnWidths.map((NameSize) => {
            if (NameSize.columnName === 'name' && NameSize.width !== 250) { IsSizeDefault = false } else { IsSizeDefault = true }
        });
        this.setState({ IsSizeDefault: IsSizeDefault });

    }

    changeSearching1 = (e) => {
        let params_for_search = {
            filterdata: this.state.filterdata,
            list: {
                limit: this.state.pageSize,
                pageno: 1,
                searchtext: e.target.value,
                sorttype: this.state.sorttype,
                type: "search",
                fieldId: this.state.fieldId,
                columnname: this.state.column_name
            },
            filterid: 1
        }
        this.getListing(params_for_search);
        this.setState({ searchText: e.target.value });
    }

    handleCompanyDialogClose = () => {
        this.setState({ shouldOpenCreateCompanyDialog: false, FullCreateCompanyDialog: false, minimizeCompanyDialog: false });
    };

    handleCompanyDialogMinimize = () => {
        this.setState(oldStateminimizeCompanyDialog => ({ minimizeCompanyDialog: !oldStateminimizeCompanyDialog.minimizeCompanyDialog }));
        this.setState({ FullCreateCompanyDialog: false })
    };

    handleCompanyDialogFull = () => {
        this.setState(oldStateFullCreateCompanyDialog => ({ FullCreateCompanyDialog: !oldStateFullCreateCompanyDialog.FullCreateCompanyDialog }));
        this.setState({ minimizeCompanyDialog: false })

    };

    setSelection = (val) => {
        let selectedIds = [];
        if (this.props.companyReducer.companyList.data.data) {
            let list_data = this.props.companyReducer.companyList.data.data;
            val.map((key) => {
                selectedIds.push(parseFloat(list_data[key].company_id));
            });
        }
        this.setState({
            selection: val,
            deleteIds: selectedIds,
            SelectedComapnyID: selectedIds
        });
    }

    handleDrawerRight = (company_id) => {
        if (this.state.company_id && (this.state.company_id === company_id)) { } else {
            this.setState({
                company_id: company_id,
                isDataLoading: true,
            }, () => {
                this.forceUpdate()
            })
        }
        setTimeout(() => {
            this.setState({
                drawerOpen: true,
            }, () => {
                this.forceUpdate()
            })
        }, 2000);
    };

    // handleDrawerRight = (company_id) => {
    //     this.setState({ company_id: company_id});
    //     setTimeout(() => {
    //         this.setState({
    //             drawerOpen: true,
    //             isDataLoading:true,
    //         }, () => {
    //             this.forceUpdate()
    //         })    
    //     }, 2000);
    // };

    closeDrawerRight = (e) => {
        this.setState({ drawerOpen: false });
    };

    handleDeleteCompany = () => {
        this.toggleDeleteDialog()
    }

    toggleDeleteDialog = () => {
        this.setState({ isDeleteConfirmDialoOpen: !this.state.isDeleteConfirmDialoOpen });
    };
    confirmDeleteCustomField = () => {
        let deleteCompanyParams = [];

        deleteCompanyParams['deleteid'] = { companyid: this.state.deleteIds };
        deleteCompanyParams['listval'] = {
            filterdata: this.state.filterdata,
            list: {
                limit: this.state.pageSize,
                pageno: 1,
                searchtext: this.state.searchText,
                sorttype: this.state.sorttype,
                type: "list",
                fieldId: this.state.fieldId,
                columnname: this.state.column_name
            },
            filterid: 1
        };

        this.props.deleteCompanyRec(this.props.apolloClient.client, deleteCompanyParams);
        this.setState({
            selection: [],
            deleteIds: []
        });
        this.toggleDeleteDialog()
    };

    handleFollowedCheckbox = (val, name) => {
        // console.log("name1", name);
        // console.log("val1", val);
        this.setState({
            filterObject: {
                ...this.state.filterObject,
                [name]: val
            }
        }, () => {
            setTimeout(() => {
                if (this.state.filterObject[name] == val) {
                    this.handleFilterSubmit()
                }
            }, 1500);
        })

    }
    handleChangeFilter = (val, name) => {
        // console.log("name", name);
        // console.log("val", val);
        this.setState({
            filterObject: {
                ...this.state.filterObject,
                [name]: val
            }
        }, () => {
            setTimeout(() => {
                if (this.state.filterObject[name] == val) {
                    this.handleFilterSubmit()
                }
            }, 1500);
        })
    };

    rangeClick = (key, id) => {
        var rangeData = this.state.filterRangeArray[key];
        if (this.state.filterRangeArray[key][0] == "" && this.state.filterRangeArray[key][1] == "") {
            rangeData = []
        }

        var value = { fieldid: id, name: key, type: "range", value: rangeData };
        this.setState({
            filterObject: {
                ...this.state.filterObject,
                [key]: value
            }
        }, () => {
            this.forceUpdate()
            setTimeout(() => {
                if (this.state.filterObject[key] == value) {
                    this.handleFilterSubmit()
                }
            }, 1500);
        })
    }
    rangeFilter = (rval, rname) => {
        let filterRangeArray = this.state.filterRangeArray;
        filterRangeArray[rname][rval.case] = rval.value;
        this.setState({ filterRangeArray })
    }

    rangeClickDate = (key, id) => {
        var rangeData = this.state.filterRangeArray[key];
        if (this.state.filterRangeArray[key][0] == "" && this.state.filterRangeArray[key][1] == "") {
            rangeData = []
        }

        var value = { fieldid: id, name: key, type: "date", value: rangeData };
        this.setState({
            filterObject: {
                ...this.state.filterObject,
                [key]: value
            }
        }, () => {
            this.forceUpdate()
            setTimeout(() => {
                if (this.state.filterObject[key] == value) {
                    this.handleFilterSubmit()
                }
            }, 1500);
        })
    }

    rangeFilterDate = (rval, rname) => {
        console.log("rname", rname);
        console.log("rval", rval);
        let filterRangeArray = this.state.filterRangeArray;
        filterRangeArray[rname][rval.case] = rval.value;
        this.setState({
            filterRangeArray
        }, () => {
            this.forceUpdate()
            setTimeout(() => {
                this.rangeClickDate(rname, rval.fieldid)
            }, 100);
        })
    }
    handleToggleFieldDisplay = (name) => {
        var exists = this.state.fieldDisplay.includes(name);
        var joined = [];
        let filterRangeArray = this.state.filterRangeArray;

        if (exists) {
            joined = this.state.fieldDisplay.filter((item) => item != name)
            if (filterRangeArray[name]) {
                //delete filterRangeArray[name];
            }
        } else {
            joined = this.state.fieldDisplay.concat(name);
            if (!filterRangeArray[name]) {
                filterRangeArray[name] = ["", ""];
            }
        }

        this.setState({ fieldDisplay: joined, filterRangeArray })
    }

    dropdownMenu = (fkey) => {
        var exists = this.state.dropdownhide.includes(fkey);
        var joined = [];
        if (exists) {
            joined = this.state.dropdownhide.filter((item) => item != fkey)
        } else {
            joined = this.state.dropdownhide.concat(fkey);
        }
        this.setState({ dropdownhide: joined })
    }

    handleFilterSubmit = () => {
        var allowToFilter = true
        var filterValuesArray = Object.keys(this.state.filterObject);
        var finalFilterData = filterValuesArray.map((k, i) => {
            let v = this.state.filterObject[k];

            if (v.value.length > 0) {
                var valuesArray = [];
                v.value.map((val, k) => {
                    if (v.type === "date") {
                        if (val == "Invalid Date") {
                            allowToFilter = false
                        } else if (val == "") {
                            valuesArray.push(val)
                        } else if (val == null) {
                            valuesArray.push("")
                        } else if (val != null) {
                            if (v.fieldid != "0") {
                                val = moment(val).format('YYYY-MM-DD');
                            } else {
                                //val = moment(val).format("X");
                                val = moment(val).format('MM/DD/YYYY');
                            }
                            valuesArray.push(val)
                        }
                    } else if (v.fieldid == '20' && val.email) {
                        valuesArray.push(val.email)
                    } else if (v.fieldid != '20' && val.name) {
                        valuesArray.push(val.name)
                    } else if (val.optionvalue) {
                        valuesArray.push(val.optionvalue)
                    } else if (v.fieldid === "28" || v.type === "range") {//tag array and value
                        valuesArray.push(val);
                    } else {
                        valuesArray.push(val);
                    }
                })


                let checkBoxKey = -1
                if (this.state.fieldsList != undefined) {
                    checkBoxKey = this.findWithAttr(this.state.fieldsList, 'id', v.fieldid);
                }

                v.value = valuesArray;
                if (v.type == "followed") {//follow/not follow filter only value is true
                    if (v.value[0] === true) {
                        return v
                    }
                } else if (checkBoxKey != -1 && this.state.fieldsList[checkBoxKey].fieldtype.id == "3" && v.value[0] == "1") {
                    return v
                } else if (checkBoxKey != -1 && this.state.fieldsList[checkBoxKey].fieldtype.id != "3") {
                    return v
                } else if (checkBoxKey != -1 && this.state.fieldsList[checkBoxKey].fieldtype.id == "3") {
                } else {
                    return v
                }
            }
        })

        //filter null and undefined object 
        finalFilterData = finalFilterData.filter(function (element) {
            return element !== undefined || (element !== undefined && element.value.length != 0);
        });
        console.log("allowToFilter", allowToFilter);
        console.log("finalFilterData", finalFilterData);
        //return
        if (allowToFilter) {
            //saveFilter Data for save in future use.
            this.setState({
                filterdata: finalFilterData
            })

            let val = {
                filterdata: finalFilterData,
                list: {
                    limit: this.state.pageSize,
                    pageno: 1,
                    searchtext: this.state.searchText,
                    sorttype: this.state.sorttype,
                    type: "list",
                    fieldId: this.state.fieldId,
                    columnname: this.state.column_name
                },
                filterid: 1
            }
            this.getListing(val)
        }
    }

    handleFilterSubmit = () => {
        var allowToFilter = true
        let copyObj = JSON.parse(JSON.stringify(this.state.filterObject));
        var filterValuesArray = Object.keys(copyObj);
        var finalFilterData = filterValuesArray.map((k, i) => {
            let v = copyObj[k];

            if (v.value.length > 0) {
                var valuesArray = [];
                v.value.map((val, k) => {
                    if (v.type === "date") {
                        if (val == "Invalid Date") {
                            allowToFilter = false
                        } else if (val == "") {
                            valuesArray.push(val)
                        } else if (val == null) {
                            valuesArray.push("")
                        } else if (val != null) {
                            //val = moment(val).format("X");
                            val = moment(val).format(this.state.dateformat);
                            valuesArray.push(val)
                        }
                    } else if (v.type == "log") {
                        valuesArray.push(val.id);
                    } else if (v.fieldid == '31' && val.email) {
                        valuesArray.push(val.email)
                    } else if (v.fieldid != '31' && val.name) {
                        valuesArray.push(val.name)
                    } else if (val.optionvalue) {
                        valuesArray.push(val.optionvalue)
                    } else if (v.fieldid === "28" || v.type === "range") {//tag array and value
                        valuesArray.push(val);
                    } else {
                        valuesArray.push(val);
                    }
                })


                let checkBoxKey = -1
                if (this.state.fieldsList != undefined) {
                    checkBoxKey = this.findWithAttr(this.state.fieldsList, 'id', v.fieldid);
                }

                v.value = valuesArray;
                if (v.type == "followed") {//follow/not follow filter only value is true
                    if (v.value[0] === true) {
                        return v
                    }
                } else if (checkBoxKey != -1 && this.state.fieldsList[checkBoxKey].fieldtype.id == "3" && v.value[0] == "1") {
                    return v
                } else if (checkBoxKey != -1 && this.state.fieldsList[checkBoxKey].fieldtype.id != "3") {
                    return v
                } else if (checkBoxKey != -1 && this.state.fieldsList[checkBoxKey].fieldtype.id == "3") {
                } else {
                    return v
                }
            }
        })

        //filter null and undefined object 
        finalFilterData = finalFilterData.filter(function (element) {
            return element !== undefined || (element !== undefined && element.value.length != 0);
        });
        console.log("allowToFilter", allowToFilter);
        console.log("finalFilterData", finalFilterData);
        if (allowToFilter) {
            //saveFilter Data for save in future use.
            this.setState({
                filterdata: finalFilterData,
                isDataLoading: true,
            })

            let val = {
                filterdata: finalFilterData,
                list: {
                    limit: this.state.pageSize,
                    pageno: 1,
                    searchtext: this.state.searchText,
                    sorttype: this.state.sorttype,
                    type: "list",
                    fieldId: this.state.fieldId,
                    columnname: this.state.column_name
                },
                filterid: 1
            }
            this.getListing(val)
        }
    }

    handleSavefilter = () => {
        if (this.state.filtername == "") {
            this.setState({ filternameError: true })
            return false
        }
        if (this.state.filterdata && this.state.filterdata.length > 0) {
            let req = {
                filterdata: this.state.filterdata,
                fitertype: this.state.fitertype,
                filtername: this.state.filtername,
                recordtypeid: this.state.recordtypeid,
            }
            this.props.saveFilterDetailCompany(this.props.apolloClient.client, req);
            this.handleSavefilterDialogeClose()
            this.setState({
                displaySelectedFilterName: this.state.filtername,
                newSavedFilterName: this.state.filtername,
            })
        } else {
            //dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, false));
        }
        setTimeout(() => {
            this.setState({
                allowStateUpdateFilter: true,
            })
        }, 1500);
    }
    updateFilter = (data) => {
        this.setState({
            filterSaveDialoge: true,
            filterUpdateId: data.id,
            filtername: data.filtername,
            fitertype: data.fitertype.toString(),
            oldFilterOption: data.filteroption,
        })
    }

    handleUpdatefilter = () => {
        if (this.state.filtername == "") {
            this.setState({ filternameError: true })
            return false
        }
        let req = {
            filterdata: this.state.oldFilterOption,
            fitertype: this.state.fitertype,
            filtername: this.state.filtername,
            filterid: parseInt(this.state.filterUpdateId),
        }
        //return
        this.props.updateFilterDetailCompany(this.props.apolloClient.client, req);
        let updateDataInState = this.findWithAttr(this.state.companyFilterListArray, 'id', this.state.filterUpdateId);
        if (updateDataInState !== -1) {
            this.state.companyFilterListArray[updateDataInState].filtername = this.state.filtername;
            this.state.companyFilterListArray[updateDataInState].fitertype = this.state.fitertype;
        }
        this.handleSavefilterDialogeClose()
    }
    updateFilterOptions = () => {
        let key = this.findWithAttr(this.props.companyReducer.companyFilterListArray.data, 'id', localStorage.getItem('selected_company_filter_id'));
        var data = ""
        if (key !== -1) {
            data = this.props.companyReducer.companyFilterListArray.data[key];
            if (this.state.filterdata && this.state.filterdata.length > 0) {
                let req = {
                    filterdata: this.state.filterdata,
                    fitertype: data.fitertype.toString(),
                    filtername: data.filtername,
                    filterid: parseInt(data.id),
                }
                this.props.updateFilterDetailCompany(this.props.apolloClient.client, req);
                this.handleSavefilterDialogeClose()
            } else {
                //dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, false));
            }
            setTimeout(() => {
                this.setState({
                    allowStateUpdateFilter: true,
                })
            }, 1500);
        }
    }
    confirmDeleteFilter = () => {
        this.props.deleteFilterCompany(this.props.apolloClient.client, parseInt(this.state.filterDeleteId));
        let removeFilterObjKey = this.findWithAttr(this.props.companyReducer.companyFilterListArray.data, 'id', this.state.filterDeleteId);
        if (removeFilterObjKey !== -1) {
            if (!this.props.companyReducer.companyFilterListArray.data[removeFilterObjKey].isdefault == true) {
                this.props.companyReducer.companyFilterListArray.data.splice(removeFilterObjKey, 1);
            }
        }
        this.filterRemoveDialoge()
    }

    filterRemoveDialoge = () => {
        this.setState({ isDeleteFilter: false, filterDeleteId: "", allowStateUpdateFilter: true })
    }
    handleSavefilterDialoge = () => {
        this.setState({ filterSaveDialoge: true })
    }
    handleSavefilterDialogeClose = () => {
        this.setState({
            filterSaveDialoge: false,
            filternameError: false,
            fitertype: "1",
            filterUpdateId: "",
            oldFilterOption: "",
            filtername: "",
        })
    }
    handleChange = (event) => {
        if (event.target.type === 'checkbox') {
            this.setState({ [event.target.name]: event.target.checked });
        }
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
    }

    updateFilterDefaultCompany = (data) => {
        this.props.updateFilterDefaultCompany(this.props.apolloClient.client, parseInt(data.id));
        setTimeout(() => {
            this.setState({
                allowStateUpdateFilter: true,
            })
        }, 2000);
    }

    findWithAttr = (array, attr, value) => {
        for (var i = 0; i < array.length; i += 1) {
            if (array[i][attr] === value) {
                return i;
            }
        }
        return -1;
    }

    handleFilterChange = (filterdata) => {
        //when Current Customers/Potential/following Customers filter select
        if (filterdata.id == "9" && filterdata.filtername == "Current Customers") {
            filterdata.filteroption = [
                {
                    fieldid: "33",
                    name: "contacttype",
                    type: "value",
                    value: ["Current Customer"],
                    checked: true,
                    text: "Current Customer"
                }
            ]
        }
        if (filterdata.id == "10") {
            filterdata.filteroption = [
                {
                    fieldid: "33",
                    name: "contacttype",
                    type: "value",
                    value: ["Potential Customer"],
                    checked: true,
                    text: "Potential Customer",
                }
            ]
        }
        if (filterdata.id == "8") {
            filterdata.filteroption = [
                {
                    fieldid: "0",
                    name: "followed",
                    type: "followed",
                    value: [true],
                    chktype: "follow",
                }
            ]
        }
        this.setState({
            filterObject: {},
            filterRangeArray: [],
            fieldDisplay: [],
            dropdownhide: [],
        }, () => {
            this.forceUpdate()
            this.setState({ displaySelectedFilterName: filterdata.filtername, currentPage: 0 })
            if (filterdata.filteroption.length > 0) {
                let filterObject = this.state.filterObject;
                let filterRangeArray = this.state.filterRangeArray;
                let displayField = []
                let dropdownhideShow = []
                var promise = new Promise((resolve, reject) => {
                    filterdata.filteroption.map((val, k) => {
                        if (val.name == "activitytype") {
                            this.setState({ activityquery: val.query })
                            if (val.value.length > 0) {
                                var arr = []
                                val.value.map(v => {
                                    var k = this.findWithAttr(this.state.masterActivityTypesList, 'id', v)
                                    if (k != -1) {
                                        arr.push(this.state.masterActivityTypesList[k])
                                    }
                                })
                                val.value = arr;

                            }
                        }

                        filterObject = {
                            ...filterObject,
                            [val.name]: val
                        }
                        if (val.name == "tags") {
                            this.setState({ tagsquery: val.query })
                        }

                        if (val.type === "range") {
                            filterRangeArray[val.name] = ["", ""];
                            filterRangeArray[val.name][0] = val.value[0];
                            filterRangeArray[val.name][1] = val.value[1];
                            this.setState({ filterRangeArray })
                            displayField.push(val.name)
                        }

                        if (val.type == "date") {
                            filterRangeArray[val.name] = ["", ""];
                            filterRangeArray[val.name][0] = val.value[0] == "" ? null : val.value[0];
                            filterRangeArray[val.name][1] = val.value[1] == "" ? null : val.value[1];
                            this.setState({ filterRangeArray })
                            if (val.value[0] != "" && val.value[1] != "") {
                                displayField.push(val.name)
                            } else if (val.value[0] != "" || val.value[1] != "") {
                                displayField.push(val.name)
                            }
                        }

                        if (val.name == "zipcode" || val.name == "city" || val.name == "state" || val.name == "country") {//hideshow ENABLE state/city/country/state
                            dropdownhideShow.push(val.name)
                        } else {
                            dropdownhideShow.push(val.name)

                        }
                    })
                    this.setState({
                        filterObject,
                        fieldDisplay: displayField,
                        dropdownhide: dropdownhideShow,
                    }, () => this.forceUpdate())
                    resolve(true)
                });

                promise.then(result => {
                    this.handleFilterSubmit();
                    localStorage.setItem('selected_company_filter_id', filterdata.id)
                });
            } else {
                let val = {
                    filterdata: [],
                    list: {
                        limit: this.state.pageSize,
                        pageno: 1,
                        searchtext: this.state.searchText,
                        sorttype: this.state.sorttype,
                        type: "list",
                        fieldId: this.state.fieldId,
                        columnname: this.state.column_name
                    },
                    filterid: 1
                }
                localStorage.setItem('selected_company_filter_id', filterdata.id)
                this.handleFilterSubmit();
            }
        })

    }

    handlechangeActivityQuery = (event) => {
        this.setState({
            activityquery: event.target.value
        }, () => {
            setTimeout(() => {
                if (this.state.filterObject['activitytype'] && this.state.filterObject['activitytype'].value.length > 0) {
                    this.state.filterObject['activitytype'].query = event.target.value;
                    this.handleFilterSubmit();
                }
            }, 1500);
        })
    }
    handlechangeTagsQuery = (event) => {
        this.setState({
            tagsquery: event.target.value
        }, () => {
            setTimeout(() => {
                if (this.state.filterObject['tags'] && this.state.filterObject['tags'].value.length > 0) {
                    this.state.filterObject['tags'].query = event.target.value;
                    this.handleFilterSubmit();
                }
            }, 1500);
        })
    }
    handleClearFilterData = () => {
        this.setState({
            fieldDisplay: [],
            filterRangeArray: [],
            dropdownhide: [],
            filterObject: {},
            filterdata: [],
            activityquery: "any",
            tagsquery: "any",
        }, () => {
            setTimeout(() => {
                // if(this.state.filterObject['tags'] && this.state.filterObject['tags'].value.length > 0){
                //     this.state.filterObject['tags'].query = event.target.value;
                //     this.handleFilterSubmit();
                // }
            }, 1500);
        })
    }

    handleContactTypeCheckbox = (val, name) => {
        var valArray = []
        if (this.state.filterObject['contacttype']) {
            valArray = this.state.filterObject['contacttype'].value
            if (val.checked) {
                valArray.push(val.text);
                val.value = valArray;
                this.setState({
                    filterObject: {
                        ...this.state.filterObject,
                        [name]: val
                    }
                })
            } else {
                if (this.state.filterObject['contacttype'].value == 0) {
                    valArray.push(val.text);
                    this.state.filterObject['contacttype'].value = valArray;
                } else {
                    var array = this.state.filterObject['contacttype'].value;
                    var index = array.indexOf(val.text)
                    if (index !== -1) {
                        array.splice(index, 1);
                        this.state.filterObject['contacttype'].value = array
                    }
                }
            }
        } else {
            if (val.checked) {
                valArray.push(val.text);
                val.value = valArray
            }
            this.setState({
                filterObject: {
                    ...this.state.filterObject,
                    [name]: val
                }
            })
        }

        this.setState({
            filterObject: {
                ...this.state.filterObject,
                [name]: val
            }
        }, () => {
            setTimeout(() => {
                if (this.state.filterObject[name] == val) {
                    this.handleFilterSubmit()
                }
            }, 1500);
        })

    }
    toggleReplayMultupleEmail = (emails) => {
        console.log("data", emails)
        this.setState({
            isOpenedReplayBulkEmail: !this.state.isOpenedReplayBulkEmail,
            userSelectedBlukEmail: this.state.relatedemails,
            mainUserData: { email: '' },
            // leadid: data.lead_id
        });
    }
    toggleReplayBulkEmailclose = () => {
        this.setState({
            isOpenedReplayBulkEmail: !this.state.isOpenedReplayBulkEmail,
        });
    }

    handleSendEmail = (event) => {
        let mailboxid = this.state.mailboxid + Server.BCCINBOX;
        let main_email = this.state.allSettings;
        let req = {
            id: this.state.SelectedComapnyID,
            type: 'contact',
            recordtype: 'company'
        }
        this.props.getRelatedContactsData(this.props.apolloClient.client, req);
        this.setState({ isDataLoading: true });
        setTimeout(() => {
            if (main_email.setting_one === 1) {
                this.toggleReplayMultupleEmail();
            } else if (main_email.setting_one === 2) {
                window.open("https://mail.google.com/mail/?view=cm&fs=1&to=" + this.state.relatedemails && this.state.relatedemails.toString() + "&bcc=" + mailboxid, '__blank');
            } else {
                window.open("https://mail.google.com/mail/?view=cm&fs=1&to=" + this.state.relatedemails && this.state.relatedemails.toString(), '__blank');
            }
            this.setState({
                selection: [],
                SelectedComapnyID: []
            });
        }, 4000);


    }

    render() {
        let { companyLogs, defaultColumnOrder, pageSize, currentPage, totalCount, companyListData, isOpenedCompanyList, isOpenedCustomFilters, isOpenedRange, shouldOpenCreateCompanyDialog, minimizeCompanyDialog, FullCreateCompanyDialog, drawerOpen } = this.state;

        const tableColumnExtensions = [
            { columnName: 'name', width: 250 },

        ];

        const columns = this.state.columns_array;

        const defaultHiddenColumnNames = this.state.defaultHiddenColumnNames;
        const tableColumnVisibilityColumnExtensions = [
            { columnName: 'name', togglingEnabled: false },
        ];
        const leftColumns = [TableSelection.COLUMN_TYPE, 'name',];

        var localStorageFilter = localStorage.getItem('selected_company_filter_id');
        let updateSaveFilterBtnDisabled = (this.state.filterdata == undefined || !this.state.filterdata.length) ? ((this.state.oldFilterOption == undefined || !this.state.oldFilterOption.length) ? true : false) : false;

        const toolbarTemplate = (params) => {
            let { searchText, pageSize, currentPage, totalCount, companyListData, isOpenedCompanyList, isOpenedCustomFilters, isOpenedRange, shouldOpenCreateCompanyDialog, minimizeCompanyDialog, FullCreateCompanyDialog, drawerOpen } = this.state;
            return (
                <div className="d-flex list_table_header">
                    <MaterialGrid container justify="space-between">
                        <MaterialGrid>
                            <MaterialGrid container justify="space-between">
                                <MaterialGrid>
                                    <h3 className="ml-16">Companies</h3>
                                </MaterialGrid>
                                {this.state.selection.length ?
                                    <MaterialGrid className="flex flex-middle ml-10">
                                        {this.state.selection.length}  selected
                                        <IconButton onClick={this.handleSendEmail} aria-label="Email" size="small" className="ml-8">
                                            <Icon>email</Icon>
                                        </IconButton>
                                        {this.state.crudPermission.isdelete &&
                                            <IconButton aria-label="Delete" size="small" onClick={() => this.handleDeleteCompany()} className="ml-8">
                                                <Icon>delete</Icon>
                                            </IconButton>
                                        }
                                        <DropdownDefault
                                            menuButton={
                                                <IconButton size="small" className="ml-8">
                                                    <Icon>more_vert</Icon>
                                                </IconButton>
                                            }
                                        >
                                            <MenuItem className="flex flex-middle">
                                                <Icon className="mr-16">call_merge</Icon> Merge Companies
                                            </MenuItem>
                                            <MenuItem className="flex flex-middle">
                                                <Icon className="mr-16">file_download</Icon> Export List
                                            </MenuItem>
                                        </DropdownDefault>
                                    </MaterialGrid>
                                    :
                                    ''
                                }
                            </MaterialGrid>
                        </MaterialGrid>
                        <MaterialGrid>
                        </MaterialGrid>
                    </MaterialGrid>
                    <TextField
                        id="search-input"
                        placeholder="Search"
                        defaultValue={searchText}
                        onChange={this.changeSearching1}
                        onKeyDown={this.keyPress}
                        autoFocus={searchText ? true : false}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Icon>search</Icon>
                                </InputAdornment>
                            ),
                        }}
                    />
                    <HiddenColumns allData={this} columns={columns} />

                    {params.children}
                    <div className="d-inline-block ml-8">
                        <DropdownDefault
                            menuButton={
                                <Button variant="contained" color="primary" size="small" className="btn_Primary" >
                                    Actions
                            </Button>
                            }
                        >
                            <Link to={'/settings/settings'}>
                                <MenuItem className="flex flex-middle">
                                    <Icon className="mr-16">format_list_numbered</Icon> Create custom fileds
                                </MenuItem>
                            </Link>
                        </DropdownDefault>
                    </div>
                    {/* <div className="d-inline-block ml-8">
                        <Button variant="contained" size="small">
                            Import
                            </Button>
                    </div> */}
                    <div className="d-inline-block ml-8 mr-16">
                        {this.state.crudPermission.iscreate &&
                            <Button variant="contained" color="secondary" onClick={() => this.setState({ shouldOpenCreateCompanyDialog: true })} size="small" style={{ minWidth: 95 }}>
                                Create New
                            </Button>
                        }

                    </div>
                </div>
            );
        };



        return (
            <React.Fragment>
                <aside className="aside_left" style={{ overflowY: 'scroll', overflow: 'auto' }}>
                    <Card elevation={3} className="pt-16">
                        <h5 onClick={this.toggleCompanyList} className="cursor_poiter d-flex justify-content-between pl-16 pr-16">
                            <TooltipNew title={this.state.displaySelectedFilterName} >
                                <div className="font-weight-500">
                                    <span style={{ maxWidth: '150px' }} className="text_ellipsis "> {this.state.displaySelectedFilterName} </span>
                                    <span className="ml-4"> ({totalCount})</span>
                                </div>
                            </TooltipNew>
                            <Icon className="vert-middle flex-end">{isOpenedCompanyList ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</Icon>
                        </h5>
                        {isOpenedCompanyList &&
                            <div className="filter_menu_custom">
                                <h6 className="mt-8 font-size-14 mb-0 pl-16 pr-16">Private Filters </h6>
                                <ul>
                                    {this.state.companyFilterListArray.length > 0 && this.state.companyFilterListArray.map((item, key) => {
                                        let star_icon = item.isdefault ? "star" : "star_border";
                                        if (item.fitertype == 1 && item.id != localStorage.getItem('selected_company_filter_id')) {
                                            return <li >
                                                <div onClick={() => this.handleFilterChange(item)}>{item.filtername}</div>
                                                <><IconButton className="text-secondary ml-4" size="small">
                                                    <Icon onClick={() => this.updateFilter(item)} style={{ marginTop: '5px', display: 'contents', fontSize: '18px' }}>{'settings'}</Icon>
                                                </IconButton>
                                                    <IconButton className="text-secondary ml-4" size="small">
                                                        <Icon onClick={() => this.setState({ isDeleteFilter: true, filterDeleteId: item.id })} style={{ marginTop: '5px', display: 'contents', fontSize: '18px' }}>{'delete'}</Icon>
                                                    </IconButton>
                                                    <IconButton className="text-secondary ml-4" size="small">
                                                        <Icon onClick={() => this.updateFilterDefaultCompany(item)} style={{ marginTop: '5px', display: 'contents', fontSize: '18px' }}>{star_icon}</Icon>
                                                    </IconButton>
                                                </>
                                            </li>
                                        }
                                    }
                                    )}
                                </ul>
                                <h6 className="mt-8 font-size-14 mb-0 mt-16 pl-16 pr-16">Public Filters</h6>
                                <ul>
                                    {this.state.companyFilterListArray.length > 0 && this.state.companyFilterListArray.map((items, key) => {
                                        let star_icon = items.isdefault ? "star" : "star_border";
                                        if (items.fitertype == 0 && items.id != localStorage.getItem('selected_company_filter_id')) {
                                            return <li >
                                                <div onClick={() => this.handleFilterChange(items)}>{items.filtername}</div>
                                                {!["7", "8", "9", "10"].includes(items.id) &&
                                                    <><IconButton className="text-secondary ml-4" size="small">
                                                        <Icon onClick={() => this.updateFilter(items)} style={{ marginTop: '5px', display: 'contents', fontSize: '18px' }}>{'settings'}</Icon>
                                                    </IconButton>
                                                        <IconButton className="text-secondary ml-4" size="small">
                                                            <Icon onClick={() => this.setState({ isDeleteFilter: true, filterDeleteId: items.id })} style={{ marginTop: '5px', display: 'contents', fontSize: '18px' }}>{'delete'}</Icon>
                                                        </IconButton></>
                                                }
                                                <IconButton className="text-secondary ml-4" size="small">
                                                    <Icon onClick={() => this.updateFilterDefaultCompany(items)} style={{ marginTop: '5px', display: 'contents', fontSize: '18px' }}>{star_icon}</Icon>
                                                </IconButton>
                                            </li>
                                        }
                                    }
                                    )}
                                </ul>

                                <><Dialog
                                    fullWidth={true}
                                    maxWidth={'xs'}
                                    open={this.state.isDeleteFilter}
                                    onClose={this.filterRemoveDialoge}
                                    disableBackdropClick

                                    aria-labelledby="ar-remove-dialog-title"
                                >
                                    <DialogTitle id="ar-remove-dialog-title">{"Are you sure you want to delete filter ?"}</DialogTitle>
                                    <DialogActions>
                                        <Button onClick={this.filterRemoveDialoge} color="primary">Cancel</Button>
                                        <Button type="Button" onClick={() => this.confirmDeleteFilter()} className="btn_Primary">
                                            Ok
                                    </Button>
                                    </DialogActions>
                                </Dialog></>
                            </div>
                        }
                    </Card>
                    <Card elevation={3} className={`pt-16 pb-16`} style={{ marginTop: '5px' }}>
                        <div className="ml-16 mr-16">
                            <Button fullWidth className="btn_Primary" size="small" onClick={this.toggleCustomFilters}><Icon>add</Icon> Add Custom Filters</Button>
                        </div>
                        {isOpenedCustomFilters &&
                            <React.Fragment>
                                <div className="v_scroll position-relative ml-16 mt-16 pr-16">
                                    <Link className="text_link" onClick={() => this.handleFilterChange(this.state.companyFilterListArray[this.state.AllCompanyFilterKey])}>Clear All</Link>
                                    {FilterComponent(this)}
                                </div>
                                <div className="fixed-bottom" style={{ position: 'initial' }}>
                                    <Button type="button" className="btn_Primary  mb-16 px-12" size="small" onClick={() => this.handleSavefilterDialoge()}>Save Filter</Button>
                                    {localStorageFilter && !["7", "8", "9", "10"].includes(localStorageFilter) &&
                                        <Button type="button" className="btn_Primary  mb-16 px-12 ml-16" size="small" onClick={() => this.updateFilterOptions()}>Update Filter</Button>
                                    }
                                </div>
                            </React.Fragment>
                        }
                    </Card>
                </aside>
                <Card elevation={3} className="fixed_layout">
                    <div className="leads_list_table">
                        <Grid rows={companyListData} columns={columns}>
                            <SelectionState
                                selection={this.state.selection}
                                onSelectionChange={this.setSelection}
                            />
                            <IntegratedSelection />
                            <VirtualTable />
                            {/* <SearchState defaultValue="" onValueChange={((val) => { this.changeSearching(val) })} /> */}
                            <IntegratedFiltering />
                            <SortingState
                                defaultSorting={this.state.defaulSortingData}
                                onSortingChange={(val => { this.changeDefaultSorting(val) })}
                                sorting={this.state.defaulSortingData}
                            />
                            {/* <IntegratedSorting /> */}
                            <DragDropProvider />
                            <PagingState
                                currentPage={currentPage}
                                pageSize={pageSize}
                                //defaultCurrentPage={defaultCurrentpage}
                                onCurrentPageChange={(page) => this.handleCurrentPage(page)}
                                onPageSizeChange={(size) => this.handlePageSize(size)}

                            />
                            <Table
                                columnExtensions={tableColumnExtensions}
                                noDataCellComponent={() => <LoadingState componetname="Company" icon="supervised_user_circle" columnCount={columns.length} loading={this.state.isDataLoading} />}
                            />

                            <TableColumnResizing
                                defaultColumnWidths={this.state.columnWidths}
                                onColumnWidthsChange={this.onColumnWidthsChange}
                            />
                            <TableSelection showSelectAll highlightRow />
                            <TableColumnReordering
                                defaultOrder={defaultColumnOrder}
                                order={defaultColumnOrder}
                                onOrderChange={(val) => { this.handleChangeColumnOrder(val) }}
                            />
                            <TableHeaderRow showSortingControls />

                            <PagingPanel
                                // pageSizes={[2, 5, 10, 15]}
                                pageSizes={[10, 25, 50, 100]}
                            />
                            <CustomPaging
                                totalCount={totalCount}
                            />
                            <TableFixedColumns
                                leftColumns={leftColumns}
                            />
                            <TableColumnVisibility
                                defaultHiddenColumnNames={defaultHiddenColumnNames}
                                hiddenColumnNames={defaultHiddenColumnNames}
                                columnExtensions={tableColumnVisibilityColumnExtensions}
                                onHiddenColumnNamesChange={(val) => { this.handleChangeColumnHidden(val) }}
                            />
                            <Toolbar rootComponent={toolbarTemplate} />
                            {/* <SearchPanel  /> */}
                            {/*  <ColumnChooser /> */}
                        </Grid>
                    </div>
                </Card>
                <Drawer
                    width={"100px"}
                    variant="temporary"
                    anchor={"right"}
                    className="drawer_right"
                    open={drawerOpen}
                    onClose={this.closeDrawerRight}
                    ModalProps={{
                        keepMounted: true
                    }}
                >
                    <CompanyProfileFrame company_id={this.state.company_id} companyLogs={companyLogs} handleClose={this.closeDrawerRight} />
                </Drawer>
                {shouldOpenCreateCompanyDialog && (
                    <CreateNewCompanyDialog
                        handleCloseCompany={() => this.handleCompanyDialogClose()}
                        openCompany={shouldOpenCreateCompanyDialog}
                        handleMinimizeCompany={() => this.handleCompanyDialogMinimize()}
                        handleFullCompany={() => this.handleCompanyDialogFull()}
                        minimizeScreenCompany={minimizeCompanyDialog}
                        fullScreenCompany={FullCreateCompanyDialog}
                        allstates={this.state}
                    />
                )}
                <Dialog
                    fullWidth={true}
                    maxWidth={'xs'}
                    open={this.state.isDeleteConfirmDialoOpen}
                    onClose={() => this.toggleDeleteDialog()}
                    disableBackdropClick

                    aria-labelledby="ar-remove-dialog-title"
                >
                    <DialogTitle id="ar-remove-dialog-title">{"Are you sure you want to remove selected Companies ?"}</DialogTitle>
                    <DialogActions>
                        <Button onClick={this.toggleDeleteDialog} color="primary">
                            Cancel
                                      </Button>
                        <Button type="Button" onClick={() => this.confirmDeleteCustomField()} className="btn_Primary">
                            Ok
                                      </Button>

                    </DialogActions>
                </Dialog>

                <Dialog
                    fullWidth={true}
                    maxWidth={'xs'}
                    open={this.state.filterSaveDialoge}
                    onClose={() => this.handleSavefilterDialogeClose()}
                    disableBackdropClick

                    aria-labelledby="delele-dialog-title"
                >
                    <DialogTitle id="">
                        {!this.state.filterUpdateId ? "Add a New Filter" : "Edit Filter"}
                    </DialogTitle>
                    <Divider />
                    <DialogContent>
                        <ValidatorForm instantValidate={false} ref="form">
                            <FormControl error={this.state.filternameError} className="w-100 input_bx">
                                <InputLabel htmlFor="component-error">Name</InputLabel>
                                <Input
                                    type="text"
                                    id={'filtername'}
                                    label={'Filter Name'}
                                    className="w-100 input_bx"
                                    onChange={(event) => this.handleChange(event)}
                                    name={'filtername'}
                                    value={this.state.filtername}
                                />
                                {this.state.filternameError && <FormHelperText id="component-error-text">This field is required</FormHelperText>}
                            </FormControl>
                            <br /><br />
                            <div>
                                <span>visibility</span>
                                <br />
                                <RadioGroup name="fitertype" value={this.state.fitertype} onChange={(event) => this.handleChange(event)} row>
                                    <FormControlLabel
                                        value="1"
                                        control={<Radio color="primary" />}
                                        label="Private"
                                        labelPlacement="end"
                                    />
                                    <FormControlLabel
                                        value="0"
                                        control={<Radio color="primary" />}
                                        label="Public"
                                        labelPlacement="end"
                                    />
                                </RadioGroup>
                            </div>

                        </ValidatorForm>
                    </DialogContent>
                    <DialogActions>
                        {updateSaveFilterBtnDisabled && <p className="lead-filter-error">Please select filter options to save filter</p>}
                        <Button onClick={() => this.handleSavefilterDialogeClose()} color="primary">
                            Cancel
                        </Button>
                        {!this.state.filterUpdateId && <Button variant="contained" disabled={updateSaveFilterBtnDisabled} type="button" className="btn_Primary" onClick={() => this.handleSavefilter()}>Save</Button>}
                        {this.state.filterUpdateId && <Button variant="contained" disabled={updateSaveFilterBtnDisabled} type="button" className="btn_Primary" onClick={() => this.handleUpdatefilter()}>Update</Button>}
                    </DialogActions>
                </Dialog>
                {this.state.isDataLoading &&
                    <Snackbar
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                        open={this.state.isDataLoading}
                        TransitionComponent={Fade}
                        message={<><CircularProgress size={20} style={{ color: 'white' }} /><span style={{ paddingLeft: '6px', color: 'white' }}>{" Loading..."}</span></>}
                        variant={'success'}
                    />
                }
                {this.state.isOpenedReplayBulkEmail &&
                    <InboxComposeMultipleDialog
                        handleClose={this.toggleReplayBulkEmailclose}
                        userSelectedEmail={this.state.userSelectedBlukEmail}
                        open={this.state.isOpenedReplayBulkEmail}
                        mainUserData={this.state.mainUserData}
                        LogDetails={{}}
                        LogComponent="Company"
                    />
                }
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        companyReducer: state.companyReducer,
        settingReducer: state.settingReducer,
        apolloClient: state.apolloClient,
        authReducer: state.authReducer

    };
};
const mapDispatchToProps = dispatch => {
    return {
        getCompanyRecFilterList: (client, request) => { dispatch(actions.getCompanyRecFilterList(client, request)) },
        updateCompanyRecListColumnOrder: (client, request) => { dispatch(actions.updateCompanyRecListColumnOrder(client, request)) },
        addFavouriteCompanyRec: (client, request) => { dispatch(actions.addFavouriteCompanyRec(client, request)) },
        deleteCompanyRec: (client, request) => { dispatch(actions.deleteCompanyRec(client, request)) },
        getCompanyRecListColumnOrder: (client) => { dispatch(actions.getCompanyRecListColumnOrder(client)) },
        getCityList: (client) => { dispatch(actions.getCityList(client)) },
        getStateList: (client) => { dispatch(actions.getStateList(client)) },
        getZipcodeList: (client) => { dispatch(actions.getZipcodeList(client)) },
        saveFilterDetailCompany: (client, request) => { dispatch(actions.saveFilterDetailCompany(client, request)) },
        getFilterListCompany: (client, recordtypeid) => { dispatch(actions.getFilterListCompany(client, recordtypeid)) },
        updateFilterDefaultCompany: (client, filterid) => { dispatch(actions.updateFilterDefaultCompany(client, filterid)) },
        updateFilterDetailCompany: (client, req) => { dispatch(actions.updateFilterDetailCompany(client, req)) },
        deleteFilterCompany: (client, req) => { dispatch(actions.deleteFilterCompany(client, req)) },
        getUserSetting: (client, data) => dispatch(actions.getUserSetting(client, data)),
        getUserList: (client) => dispatch(actions.getUserList(client)),
        getActivityTypes: (client) => dispatch(actions.getActivityTypes(client)),
        getUserIntegration: (client) => dispatch(actions.getUserIntegration(client)),
        saveRingCentralData: (client, value) => dispatch(actions.saveRingCentralData(client, value)),
        getRelatedContactsData: (client, value) => dispatch(actions.getRelatedContactsData(client, value)),
        generateMailBoxId: (client) => { dispatch(actions.generateMailBoxId(client)) },
        getEmailSetting: (client) => dispatch(actions.getEmailSetting(client)),
    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(CompanyList);
